import getConfig from 'next/config'

import { PATHS } from '../paths'

const { publicRuntimeConfig } = getConfig()
const {
  MONEYTREE_VAULT_URL,
  MONEYTREE_CLIENT_ID,
  SLACK_APP_CLIENT_ID,
  BASE_URL,
  FRESHDESK_URL,
} = publicRuntimeConfig

export const EXTERNAL_LINKS = {
  LP: {
    LINK: 'https://up-sider.com/',
  },
  SUPPORT: {
    FAQ: {
      LINK: 'https://help.up-sider.com/customer/login',
    },
    RELEASE_NOTES: {
      LINK: 'https://help.up-sider.com/support/solutions/articles/72000591965',
    },
    DEPOSIT: {
      LINK: 'https://help.up-sider.com/support/solutions/articles/72000582614',
    },
    ACCOUNTING: {
      LINK: 'https://help.up-sider.com/support/solutions/articles/72000599563',
    },
    DELETE_SLACK_APP: {
      LINK: 'https://help.up-sider.com/support/solutions/articles/72000582635-upsider-slack-app%E3%81%AE%E5%89%8A%E9%99%A4%E6%96%B9%E6%B3%95',
    },
    UPLOAD_EVIDENCE_FROM_SLACK: {
      LINK: 'https://help.up-sider.com/support/solutions/articles/72000591992',
    },
    UPLOAD_EVIDENCE_FROM_TEAMS: {
      LINK: 'https://help.up-sider.com/support/solutions/articles/72000637288',
    },
    SLACK_INTEGRATION_SETTINGS: {
      LINK: 'https://help.up-sider.com/support/solutions/articles/72000582503#%E3%80%90STEP1%E3%80%91%C2%A0UPSIDER-Slack-App%E3%81%AE%E3%82%A4%E3%83%B3%E3%82%B9%E3%83%88%E3%83%BC%E3%83%AB&%E3%83%81%E3%83%A3%E3%83%8D%E3%83%AB%E8%BF%BD%E5%8A%A0',
    },
    EXTINGUISHMENT_OF_GUARANTEE_MONEY: {
      LINK: 'https://help.up-sider.com/support/solutions/articles/72000612917',
    },
    RECOVERY_CODE: {
      LINK: 'https://help.up-sider.com/support/solutions/articles/72000590686',
    },
    IDP_CONNECTION: {
      LINK: 'https://help.up-sider.com/support/solutions/articles/72000626021-saml%E8%AA%8D%E8%A8%BC%E3%83%BB%E3%82%B7%E3%83%B3%E3%82%B0%E3%83%AB%E3%82%B5%E3%82%A4%E3%83%B3%E3%82%AA%E3%83%B3%E3%81%A7%E3%81%AE%E3%83%AD%E3%82%B0%E3%82%A4%E3%83%B3',
    },
    CREATE_ACCOUNT: {
      LINK: 'https://help.up-sider.com/support/solutions/folders/72000561621',
    },
    MONEYTREE_CONNECTION: {
      LINK: 'https://help.up-sider.com/support/solutions/articles/72000583215',
    },
    CARD_GROUP_SETTINGS: {
      LINK: 'https://help.up-sider.com/support/solutions/articles/72000583103',
    },
    ISSUE_CARD: {
      LINK: 'https://help.up-sider.com/support/solutions/articles/72000583298',
    },
    CHECK_PIN: {
      LINK: 'https://help.up-sider.com/support/solutions/articles/72000582735',
    },
  },
  MONEYTREE: {
    SERVICE_MANAGEMENT: {
      // https://docs.link.getmoneytree.com/docs/link-vault-page
      LINK: (backTo?: string) => {
        const configs = backTo
          ? `authn_method%3Dsso%26force_logout%3Dtrue%26back_to=${backTo}`
          : 'authn_method%3Dsso%26force_logout%3Dtrue'
        return `${MONEYTREE_VAULT_URL}?client_id=${MONEYTREE_CLIENT_ID}&configs=${configs}`
      },
    },
    SERVICES: {
      LINK: (backTo?: string) => {
        const configs = backTo
          ? `authn_method%3Dsso%26force_logout%3Dtrue%26back_to=${backTo}`
          : 'authn_method%3Dsso%26force_logout%3Dtrue'
        return `${MONEYTREE_VAULT_URL}/services/corporate?client_id=${MONEYTREE_CLIENT_ID}&configs=${configs}`
      },
    },

    // TODO:ここより下はsettings/conpanyの移行時に削除予定
    BANK: {
      LINK: `${MONEYTREE_VAULT_URL}/services/corporate/grouping_bank`,
    },
    CREDIT_UNION: {
      LINK: `${MONEYTREE_VAULT_URL}/services/corporate/grouping_credit_union`,
    },
    WORKERS_CREDIT_UNION: {
      LINK: `${MONEYTREE_VAULT_URL}/services/corporate/grouping_credit_coop`,
    },
    LOCAL_BANK: {
      LINK: `${MONEYTREE_VAULT_URL}/services/corporate/grouping_regional_bank`,
    },
  },
  SLACK: {
    DOWNLOAD_MEMBER_LIST: {
      LINK: 'https://slack.com/intl/ja-jp/help/articles/4405848563603-%E3%83%AF%E3%83%BC%E3%82%AF%E3%82%B9%E3%83%9A%E3%83%BC%E3%82%B9%E3%81%AE%E3%83%A1%E3%83%B3%E3%83%90%E3%83%BC%E3%83%AA%E3%82%B9%E3%83%88%E3%82%92%E3%83%80%E3%82%A6%E3%83%B3%E3%83%AD%E3%83%BC%E3%83%89%E3%81%99%E3%82%8B',
    },
    OAUTH_URL: {
      LINK: (scope: string) =>
        `https://slack.com/oauth/v2/authorize?client_id=${SLACK_APP_CLIENT_ID}&scope=${scope}&user_scope=&redirect_uri=${BASE_URL}${PATHS.SETTINGS_SLACK_NOTIFICATION}/`,
    },
  },
  FREEE: {
    LINK: 'https://www.freee.co.jp/',
  },
  FRESHDESK: {
    LINK: ({ token, queryString }: { token: string; queryString: string }) =>
      `${FRESHDESK_URL}?id_token=${token}${
        queryString ? `&${queryString.replace(/^&/, '')}` : ''
      }`,
  },
  NOTION: {
    PROMOTION: {
      LINK: 'https://upsiders.notion.site/upsiders/5c68b605d1a74f6789b1f0ac0464dfe4',
    },
  },
  TEAMS: {
    APP_SOURCE_URL: {
      LINK: 'https://appsource.microsoft.com/en-us/product/office/WA200007742',
    },
  },
  NATIONAL_CORPORATION_SEARCH: {
    LINK: 'https://www.houjin-bangou.nta.go.jp/',
  },
  SUPPLEMENTAL_DOCUMENT_TEMPLATE:
    'https://app.box.com/s/7vacecetr8cf1odj4bgrqeexbq3g295l',
  TRUSTDOCK: 'https://biz.trustdock.io/',
  PRESIDENT: {
    SUPPORT: {
      DEPOSIT: {
        LINK: 'https://www.notion.so/upsiders/16793c7ce32d805c8310f4bae4e70698',
      },
      EXTINGUISHMENT_OF_GUARANTEE_MONEY: {
        LINK: 'https://www.notion.so/upsiders/16793c7ce32d804f9a15f6fa1a7ae649',
      },
      FAQ: {
        LINK: 'https://www.notion.so/upsiders/PRESIDENT-CARD-16593c7ce32d8066b73fc2dd81b928b5',
        CHECK_PIN: {
          LINK: 'https://www.notion.so/upsiders/PIN-4-16e93c7ce32d80599974e4bdc6da7f9c',
        },
      },
      MONEYTREE_CONNECTION: {
        LINK: 'https://www.notion.so/upsiders/Moneytree-16793c7ce32d80879d5ff1ee5bd7472a',
      },
    },
  },
}
